import React from 'react';

function App() {
	return <div className="App">EventEditPage</div>;
}

export default App;
